import { setCurrentPage } from '@/store/account/slice';
import { useAppDispatch } from '@/store/hooks/useAppDispatch';
import { ReceptionistDashboardSiderItem } from 'src/enums/EReceptionistDashboardSiderItem';
import { Button, Tag, Card, Tooltip } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';

interface InboundAgentCardProps {
	icon: React.ReactNode;
	name: string;
	status: string;
	linkTo?: ReceptionistDashboardSiderItem;
	onExpand?: () => void;
	isExpandable?: boolean;
	className?: string;
	onOpen?: () => void;
	onDelete?: () => void;
	loading?: boolean;
	disabled?: boolean;
}

const InboundAgentCard: React.FC<InboundAgentCardProps> = ({
	icon,
	name,
	status,
	linkTo,
	onExpand,
	isExpandable,
	className = '',
	onOpen,
	onDelete,
	loading = false,
	disabled = false,
}) => {
	const dispatch = useAppDispatch();

	const handleClick = () => {
		if (isExpandable && onExpand) {
			onExpand();
		} else if (linkTo) {
			dispatch(setCurrentPage(linkTo));
		}
	};

	return (
		<Card className={`agent-card ${className || ''}`} onClick={handleClick}>
			<div className="flex items-center justify-between">
				<div className="flex items-center gap-4">
					<div className="flex items-center justify-center w-9 h-9 rounded-lg text-base bg-blue-50 text-blue-600">
						{icon}
					</div>
					<div>
						<div className="font-medium text-gray-800">{name}</div>
						<div className="text-sm text-gray-500">{status}</div>
					</div>
				</div>
				<div className="flex items-center gap-2">
					{status === 'active' && <Tag color="green">Active</Tag>}
					{status === 'demo' && <Tag color="blue">Demo</Tag>}
					{onOpen && (
						<Button
							type="primary"
							onClick={(e) => {
								e.stopPropagation();
								onOpen();
							}}
							disabled={disabled}
						>
							Open
						</Button>
					)}
					{status !== 'demo' && onDelete && (
						<Tooltip title="Delete Agent">
							<Button
								type="text"
								danger
								icon={<DeleteOutlined />}
								loading={loading}
								onClick={(e) => {
									e.stopPropagation();
									onDelete();
								}}
								disabled={disabled}
							/>
						</Tooltip>
					)}
				</div>
			</div>
		</Card>
	);
};

export default InboundAgentCard;
